import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import type { NotificationField } from '../../../types'

/**
 * Builds active notification field options alphabetically.
 */
export function useFieldOptions(
  fields: NotificationField[],
  type?: NotificationField['type']
) {
  return useOptions({
    items: fields
      .filter((field) => !type || field.type === type)
      .filter(({ deleted }) => !deleted)
      .map(({ id, name, tooltip }) => ({
        id,
        name,
        tooltip,
      })),
    label: 'name',
    sort: 'name',
    tooltip: 'tooltip',
    value: 'id',
  })
}
